export const tileRowGap = 5;

export const desktopAspectX = '3';
export const desktopAspectY = '5';
export const desktopAspect = `${desktopAspectX} / ${desktopAspectY}`;

export const mobileAspectX = '1';
export const mobileAspectY = '2';
export const mobileAspect = `${mobileAspectX} / ${mobileAspectY}`;
